<template>
  <v-container>
    <v-snackbar centered color="error" :value="this.error" timeout="5000">{{ this.error }}</v-snackbar>
    <div class="d-flex mb-2">
      <v-spacer></v-spacer>
      <router-link class="routerlink black--text" to="/home"><v-btn small color="primary" @click="add" fab elevation="0"><v-icon>mdi-chevron-left</v-icon></v-btn></router-link>
    </div>
    <v-form>
      <v-select outlined persistent-placeholder v-model="type" :items="['Sportler','Trainer']" label="Benutzer-Typ" required></v-select>
      <v-text-field outlined persistent-placeholder maxlength="50" v-model="name" :rules="nameRules" label="Name" required></v-text-field>
      <v-text-field outlined persistent-placeholder maxlength="50" v-model="vorname" :rules="nameRules" label="Vorname" required></v-text-field>
      <v-text-field outlined persistent-placeholder maxlength="50" v-model="email" :rules="emailRules" label="E-Mail" required></v-text-field>
      <div class="d-flex">
        <v-select outlined persistent-placeholder style="max-width:100px" class="mr-3" :rules="telLandRules" v-model="tel_land" :items="tel_land_auswahl" label="Telefon" prefix="+" required></v-select>
        <v-text-field outlined persistent-placeholder maxlength="20" v-model="tel" :rules="telRules" required></v-text-field>
      </div>
      <v-file-input outlined persistent-placeholder v-model="bild" label="Bild" accept="image/jpeg" truncate-length="50" :prepend-icon="null" prepend-inner-icon="mdi-camera"></v-file-input>
      <v-btn color="primary" class="mt-5" block @click="save">Anlegen</v-btn>
    </v-form>
  </v-container>
</template>

<script>

import axios from 'axios';

  export default {
    name: 'useradd',

    data: () => ({
      name: "",
      vorname: "",
      email: "",
      tel_land: "",
      tel: "",
      tel_land_auswahl: ["","49","43"],
      type: "Sportler",
      bild: null,
      uploading: false,
      error: false,
      nameRules: [
        v => !!v || 'Angabe erforderlich',
      ],
      emailRules: [
        v => !!v || 'E-Mail ist erforderlich',
        v => /.+@.+\..+/.test(v) || 'E-Mail ist ungültig',
      ],
      telLandRules: [
        v => !!v || 'erforderlich',
        v => /[0-9]+/.test(v) || 'ungültig',
      ],
      telRules: [
        v => !!v || 'Telefonnummer ist erforderlich',
        v => /[0-9]+/.test(v) || 'Telefonnummer ist ungültig',
      ],
    }),
    computed:{

    },
    methods:{
      async save() {
        this.uploading = true;
        let formData = new FormData();
        formData.append("bild", this.bild);
        formData.append("name", this.name);
        formData.append("vorname", this.vorname);
        formData.append("email", this.email);
        formData.append("tel_land", this.tel_land);
        formData.append("tel", this.tel);
        formData.append("type", this.type);
        
        await axios.post(process.env.VUE_APP_APIURL+"user/",formData,{
          headers: {
            'token': localStorage.getItem('token'),
            "Content-Type": "multipart/form-data"
          }
        }).then(() => {
          this.uploading = false;
          this.$router.push('/home')
        }).catch((error) => {
          this.error = error.message
        })
      },
    },
    mounted(){

    },
  }
</script>
